let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jU99q")).then(() => parcelRequire('2EEnO'));